export default {
    namespaced: true,
    state: {
        ids: {},
        loadingPromises: {}
    },
    mutations: {
        setIds(state, {tableName, ids}) {
            state.ids[tableName] = ids
        },
        setLoadingPromise(state, {tableName, promise}) {
            state.loadingPromises[tableName] = promise
        }
    },
    actions: {
        async get({state, commit, dispatch}, {tableName}) {
            if (state.ids[tableName]) return state.ids[tableName]
            if (state.loadingPromises[tableName]) return state.loadingPromises[tableName]
            
            const promise = dispatch('request/get', {
                url: 'api/component/' + tableName + '/id'
            }, {root: true})
                .then(data => {
                    const ids = data.data.values
                    commit('setIds', {tableName, ids})
                    commit('setLoadingPromise', {tableName, promise: null})
                    return ids
                })
                .catch(err => {
                    commit('setLoadingPromise', {tableName, promise: null})
                    throw err
                })
            
            commit('setLoadingPromise', {tableName, promise})
            return promise
        }
    }
}